import db from '@/firebase/init'
import moment from "moment";
import * as firebase from "../../firebase";

let freundeinfo=[];
let messages=[];
let actualuser;

//hole Chats von der jeweiligen Person
export function modulgetChats(ref1, ref2, fmessages, name, neuePerson) {
  if (fmessages.length != 0) {
    fmessages.splice(0, fmessages.length)
  }
  messages = fmessages;

   ref1.get().then(snapshot => {
    snapshot.forEach((doc) => {
      messages.push({
        id: doc.id,
        name: doc.data().name,
        content: doc.data().content,
        timestamp: moment(doc.data().timestamp).format('lll')
      })
    })
  }).then(() => {
    console.log(messages.length)
  })
     .catch(err => {
       console.log('Error modulgetChats ref1', err);
     });

  ref2.get().then(snapshot => {
    snapshot.forEach((doc) => {
      messages.push({
        id: doc.id,
        name: doc.data().name,
        content: doc.data().content,
        timestamp: moment(doc.data().timestamp).format('lll')
      })
    })
  }).then(() => {
    console.log(messages.length)
  })
    .catch(err => {
      console.log('Error modulgetChats ref2', err);
    });

  return messages;
}

//hole Chats von der jeweiligen Person
export function modulgetChatsOnlyName(ref1,fmessages, name) {
  if (fmessages.length != 0) {
    fmessages.splice(0, fmessages.length)
  }
  messages = fmessages;

  ref1.get().then(snapshot => {
    snapshot.forEach((doc) => {
      messages.push({
        id: doc.id,
        name: doc.data().name,
        content: doc.data().content,
        timestamp: moment(doc.data().timestamp).format('lll')
      })
    })
  }).then(() => {
    console.log(messages.length)
  })
    .catch(err => {
      console.log('Error modulgetChatsOnlyName', err);
    });
  return messages;
}

export function modulgetFriends(ref1,name){
  let freunde=[];
  ref1.get().then(snapshot=>{
    snapshot.forEach((doc)=>{
      freunde.push({
        friends:doc.data().friends
      })
    })
  }).then(()=>{
    modulgetInformationOfFriends(freunde)})
    .catch(err => {
      console.log('Error getting documents getFriends', err);
    }); ;
  return freundeinfo;
};

//Hole die Freunde von der jeweiligen Person
export function modulgetInformationOfFriends(freunde){
  var ref;
  if (freundeinfo.length!=0){
    freundeinfo.splice(0, freundeinfo.length)
  }

  const freundeinformationen=freunde[0].friends;
  for(let i=0;i<freundeinformationen.length;i++){
    ref=db.collection('friends').where('name',  '==', freundeinformationen[i]);
    ref.get().then(snapshot=>{
      snapshot.forEach((doc)=>{
        freundeinfo.push({
          id: doc.id,
          name: doc.data().name,
          alter: doc.data().alter,
          region: doc.data().region,
          img: doc.data().img,
        })
      })
    }).then(()=>{
      console.log("output getInformationOfFriends")
    })
      .catch(err => {
        console.log('Error getting documents getInformation', err);
      });
  }
  return freundeinfo;
};




// WEBPACK FOOTER //
// ./src/firebase/PrivatChatDBFunction.js